import { render, staticRenderFns } from "./AdminInvoiceItemForm.vue?vue&type=template&id=be8c57da&scoped=true&"
import script from "./AdminInvoiceItemForm.vue?vue&type=script&lang=ts&"
export * from "./AdminInvoiceItemForm.vue?vue&type=script&lang=ts&"
import style0 from "./AdminInvoiceItemForm.vue?vue&type=style&index=0&id=be8c57da&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be8c57da",
  null
  
)

export default component.exports
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QSeparator from 'quasar/src/components/separator/QSeparator.js';
import qInstall from "../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QBtn,QSeparator});
